<template>
  <article class="flex gap-3">
    <div class="w-[120px]">
      <BaseLocaleLink :to="route">
        <BaseRatio :ratio="9 / 16" size="cover">
          <ClientOnly>
            <div
              class="w-full h-full rounded-xl overflow-hidden flex items-center justify-center bg-gray-200"
            >
              <img
                v-if="previewImage"
                loading="lazy"
                class="w-full"
                :src="previewImage"
                :alt="video.title"
                @load="(event) => getFallbackImage(event)"
              />
              <BaseIcon
                v-else
                name="solid_play"
                size="lg"
                class="text-gray-900"
              />
            </div>
          </ClientOnly>
        </BaseRatio>
      </BaseLocaleLink>
    </div>
    <div class="flex-1 flex flex-col">
      <BaseLink theme="dark" class="!inline py-1" :to="route">
        <h2 class="font-bold text-xs text-gray-900 line-clamp-2">
          {{ video.title }}
        </h2>
      </BaseLink>
      <div v-if="video.date" class="text-gray-500 text-xs">
        {{ getFormattedDate(video.date) }}
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { useVideo } from '~/stores/video'
import type { Video } from '~/models/video'
import { useNavigation } from '~/stores/navigation'

interface PropsInterface {
  video: Video
}

const props = defineProps<PropsInterface>()

const { VideoPreviewFallbackGetters, getVideoId, getVideoPreview } = useVideo()
const { getFormattedDate } = useDate()
const { getCategoryItemsByIds } = useNavigation()

const categories = getCategoryItemsByIds(
  props.video.categories.map((category) => category.id),
  'video'
)

const route = {
  name: 'video-category-item-id',
  params: {
    id: props.video.id,
    category: categories[0].slug,
  },
}

const previewImage = computed((): string => {
  const videoId = getVideoId(props.video)

  return (
    props.video.preview?.url ||
    getVideoPreview(props.video.video_source, videoId) ||
    ''
  )
})

function getFallbackImage(event: Event) {
  props.video.video_source &&
    VideoPreviewFallbackGetters[props.video.video_source]?.(
      event,
      props.video.video_id
    )
}
</script>
